<template>
  <div>

    <PinyinPreview :text="subject" :pinyin="subjectPinyin"></PinyinPreview>

    <AudioView v-if="entity.answerAudio" :src="entity.answerAudio"></AudioView>

  </div>
</template>

<script>
import PinyinPreview from '../../PinyinPreview.vue'
import AudioView from './../../AudioView'

export default {
  name: 'XsdView',
  components: { AudioView, PinyinPreview },
  props: {
    type: {
      type: Object,
      default: () => {
        return {}
      }
    },
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'card'
    }
  },
  data () {
    return {}
  },
  computed: {
    subject () {
      if (!this.entity || !this.entity.subject) return ''
      let parts = this.entity.subject.split(' ')
      let answers = this.entity.answers || []
      answers.forEach(n => {
        parts[n.position] += '=' + n.text
      })
      return parts.join(' ')
    },
    subjectPinyin () {
      if (!this.entity || !this.entity.subjectPinyin) return ''
      let parts = this.entity.subjectPinyin.split(' ')
      let answers = this.entity.answers || []
      answers.forEach(n => {
        parts[n.position] += '=' + n.pinyin
      })
      return parts.join(' ')
    }
  }
}
</script>
